import { request } from '_api/v1/base/behemoth/client'

export const getPermissions = async () => {
    return await request('GET', 'user/permission/')
}
